"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = GtldListColumn;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _gtldItem = _interopRequireDefault(require("./gtld-item"));
var _react2 = require("@linaria/react");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _card = _interopRequireDefault(require("@ux/card"));
var _table = require("@ux/table");
var _breakpoints = require("@site/pattern-library-utils/breakpoints");
var _density = require("@site/pattern-library-utils/density");
const ListContainer = /*#__PURE__*/(0, _react2.styled)(_card.default)({
  name: "ListContainer",
  class: "pl-lunmq6t"
});
const TableContainer = /*#__PURE__*/(0, _react2.styled)("table")({
  name: "TableContainer",
  class: "pl-tsyry8h"
});
const NoResultsContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "NoResultsContainer",
  class: "pl-n26i94g"
});
function GtldListColumn({
  gtldList,
  noResultsMessage,
  generateGtldCta,
  generateCtaButtonType,
  statusList,
  isFollowing,
  isMobile
}) {
  const hasResults = gtldList?.length > 0;
  return /*#__PURE__*/_react.default.createElement(ListContainer, {
    "data-cy": "gtld-list-column"
  }, !hasResults && /*#__PURE__*/_react.default.createElement(NoResultsContainer, {
    "data-cy": "no-results"
  }, noResultsMessage), hasResults && /*#__PURE__*/_react.default.createElement(TableContainer, {
    "data-cy": "gtld-table",
    density: "lg",
    stretch: "true"
  }, /*#__PURE__*/_react.default.createElement(_table.Tbody, null, gtldList && gtldList.map((gtld, index) => /*#__PURE__*/_react.default.createElement(_gtldItem.default, {
    key: `gtld-${gtld.id}`,
    gtld: gtld,
    handleGtldCta: generateGtldCta(index, gtld),
    ctaDesign: generateCtaButtonType(gtld),
    statusList: statusList,
    isFollowing: isFollowing,
    isMobile: isMobile
  })))));
}
GtldListColumn.propTypes = {
  generateGtldCta: _propTypes.default.func,
  generateCtaButtonType: _propTypes.default.func,
  statusList: _propTypes.default.array.isRequired,
  isFollowing: _propTypes.default.func.isRequired,
  isMobile: _propTypes.default.bool.isRequired,
  gtldList: _propTypes.default.arrayOf(_propTypes.default.shape({
    id: _propTypes.default.number,
    name: _propTypes.default.string,
    value: _propTypes.default.string,
    href: _propTypes.default.string,
    status: _propTypes.default.number,
    statusText: _propTypes.default.string,
    following: _propTypes.default.bool,
    categories: _propTypes.default.arrayOf(_propTypes.default.number),
    hasFollowCta: _propTypes.default.bool,
    followUrl: _propTypes.default.string,
    unfollowUrl: _propTypes.default.string,
    ctaLabel: _propTypes.default.string,
    followCtaLabel: _propTypes.default.string,
    unfollowCtaLabel: _propTypes.default.string
  })),
  noResultsMessage: _propTypes.default.string
};